import { Money } from "shared/types";

export enum EditModalContext {
  CurrentStatus = "Edit current status & available by date",
  RentAmount = "Edit rent amount",
  HomeRentAmount = "Edit home rent amount",
  SiteRentAmount = "Edit site rent amount"
}

export interface EditUnitSettings {
  occupied?: boolean;
  available_at?: string;
  pms_available_at_override?: boolean;
  pms_monthly_rent_amount_override?: boolean;
  pms_home_rent_amount_override?: boolean;
  pms_site_rent_amount_override?: boolean;
  monthly_rent_amount?: Money;
  home_rent_amount?: Money;
  site_rent_amount?: Money;
  pms_occupied_override?: boolean;
  listed?: boolean;
}
